/* eslint-disable */
/**
 * @note This is an auto-generated file. Do not modify it directly.
 * @see https://devdocs.transfix.io/graphql
 *
 * If you need to update the hooks or definitions in this file:
 * 1. Edit the .graphql file in this directory with the same name
 * 2. Run `npm run generate:graphql:mp` in the terminal
 */

import * as Types from '../../../../../types/graphqlTypes'

import { gql } from '@apollo/client'
import { ShipmentResponseFragmentDoc } from '../../../pages/shipment-details/graphql/ShipmentResponseFragment'
import * as Apollo from '@apollo/client'
const defaultOptions = {}
export type ICoverShipmentMutationVariables = Types.Exact<{
  input: Types.ICoverShipmentInput
}>

export type ICoverShipmentMutation = { __typename?: 'Mutation' } & {
  coverShipment?: Types.Maybe<
    { __typename?: 'CoverShipmentPayload' } & Pick<
      Types.ICoverShipmentPayload,
      'clientMutationId'
    > & {
        errors: Array<{ __typename?: 'Error' } & Pick<Types.IError, 'key' | 'message'>>
        shipment?: Types.Maybe<
          { __typename?: 'Shipment' } & Pick<
            Types.IShipment,
            | 'id'
            | 'canCancel'
            | 'carrierApplicationId'
            | 'shipperRateType'
            | 'state'
            | 'truckNumber'
            | 'trailerNumber'
            | 'truckNumberRequired'
            | 'trailerNumberRequired'
            | 'carrierRate'
            | 'vin'
          > & {
              activeCarrierAssignment?: Types.Maybe<
                { __typename?: 'CarrierAssignment' } & Pick<
                  Types.ICarrierAssignment,
                  'id' | 'bounced' | 'trackingMethod'
                > & {
                    driver?: Types.Maybe<
                      { __typename?: 'User' } & Pick<
                        Types.IUser,
                        'id' | 'fullName' | 'parentUserId' | 'email' | 'phone' | 'cellPhone'
                      >
                    >
                    dispatcher?: Types.Maybe<
                      { __typename?: 'User' } & Pick<
                        Types.IUser,
                        'id' | 'fullName' | 'parentUserId' | 'email' | 'phone' | 'cellPhone'
                      >
                    >
                    carrierApplication: { __typename?: 'CarrierApplication' } & Pick<
                      Types.ICarrierApplication,
                      'id' | 'name' | 'dotNumber' | 'mcNumber' | 'state' | 'fmcsaRating'
                    > & {
                        headquarter?: Types.Maybe<
                          { __typename?: 'Location' } & Pick<
                            Types.ILocation,
                            'id' | 'city' | 'stateCode'
                          >
                        >
                        primaryCarrierManager?: Types.Maybe<
                          { __typename?: 'User' } & Pick<
                            Types.IUser,
                            'id' | 'parentUserId' | 'fullName'
                          >
                        >
                      }
                  }
              >
              carrierManager?: Types.Maybe<
                { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
              >
              contactPreferences: { __typename?: 'ContactPreference' } & Pick<
                Types.IContactPreference,
                'carrierContactInstructions'
              >
              coveredBid?: Types.Maybe<
                { __typename?: 'Bid' } & Pick<
                  Types.IBid,
                  'id' | 'amount' | 'carrierContactUserId'
                > & {
                    carrierAvailableTruck?: Types.Maybe<
                      { __typename?: 'CarrierAvailableTruck' } & Pick<
                        Types.ICarrierAvailableTruck,
                        'id' | 'trailerNumber' | 'truckNumber' | 'vin'
                      >
                    >
                    carrierApplication?: Types.Maybe<
                      { __typename?: 'CarrierApplication' } & Pick<
                        Types.ICarrierApplication,
                        'id' | 'name' | 'dotNumber' | 'mcNumber' | 'state' | 'fmcsaRating'
                      > & {
                          headquarter?: Types.Maybe<
                            { __typename?: 'Location' } & Pick<
                              Types.ILocation,
                              'id' | 'city' | 'stateCode'
                            >
                          >
                          primaryCarrierManager?: Types.Maybe<
                            { __typename?: 'User' } & Pick<
                              Types.IUser,
                              'id' | 'parentUserId' | 'fullName'
                            >
                          >
                        }
                    >
                    carrierContactUser?: Types.Maybe<
                      { __typename?: 'User' } & Pick<
                        Types.IUser,
                        'id' | 'fullName' | 'parentUserId' | 'email' | 'phone' | 'cellPhone'
                      >
                    >
                    driver?: Types.Maybe<
                      { __typename?: 'User' } & Pick<
                        Types.IUser,
                        'id' | 'fullName' | 'parentUserId' | 'email' | 'phone' | 'cellPhone'
                      >
                    >
                  }
              >
              characteristics: { __typename?: 'ShipmentCharacteristics' } & Pick<
                Types.IShipmentCharacteristics,
                | 'backhaulEligible'
                | 'bounceCount'
                | 'hasDropTrailerStops'
                | 'hot'
                | 'mustGo'
                | 'rolloverCount'
                | 'sameDaySpot'
                | 'isHighRisk'
              >
              currentCeRep?: Types.Maybe<
                { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'parentUserId' | 'fullName'>
              >
              equipment: { __typename?: 'Equipment' } & Pick<
                Types.IEquipment,
                'id' | 'key' | 'name' | 'parentKey'
              >
              firstPickup: { __typename?: 'ShipmentStop' } & Pick<
                Types.IShipmentStop,
                'id' | 'city' | 'dropTrailer' | 'stateCode' | 'zipcode'
              >
              lastDelivery: { __typename?: 'ShipmentStop' } & Pick<
                Types.IShipmentStop,
                'id' | 'city' | 'dropTrailer' | 'stateCode' | 'zipcode'
              >
              rateConfirmationAgreement?: Types.Maybe<
                { __typename?: 'RateConfirmationAgreement' } & Pick<
                  Types.IRateConfirmationAgreement,
                  'id' | 'carrierSignedAt'
                > & { signedBy: { __typename?: 'User' } & Pick<Types.IUser, 'id' | 'fullName'> }
              >
              shipperApplication: { __typename?: 'ShipperApplication' } & Pick<
                Types.IShipperApplication,
                'id' | 'name'
              >
              statusDetails: { __typename?: 'ShipmentStatus' } & Pick<
                Types.IShipmentStatus,
                'detailedState'
              >
              stops: Array<
                { __typename?: 'ShipmentStop' } & Pick<
                  Types.IShipmentStop,
                  | 'id'
                  | 'city'
                  | 'dropTrailer'
                  | 'stateCode'
                  | 'stopType'
                  | 'stopSequence'
                  | 'zipcode'
                >
              >
            }
        >
      }
  >
}

export const CoverShipmentDocument = gql`
  mutation CoverShipment($input: CoverShipmentInput!) {
    coverShipment(input: $input) {
      clientMutationId
      errors {
        key
        message
      }
      shipment {
        ...ShipmentResponse
      }
    }
  }
  ${ShipmentResponseFragmentDoc}
`
export type ICoverShipmentMutationFn = Apollo.MutationFunction<
  ICoverShipmentMutation,
  ICoverShipmentMutationVariables
>

/**
 * __useCoverShipmentMutation__
 *
 * To run a mutation, you first call `useCoverShipmentMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCoverShipmentMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [coverShipmentMutation, { data, loading, error }] = useCoverShipmentMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCoverShipmentMutation(
  baseOptions?: Apollo.MutationHookOptions<ICoverShipmentMutation, ICoverShipmentMutationVariables>
) {
  const options = { ...defaultOptions, ...baseOptions }
  return Apollo.useMutation<ICoverShipmentMutation, ICoverShipmentMutationVariables>(
    CoverShipmentDocument,
    options
  )
}
export type CoverShipmentMutationHookResult = ReturnType<typeof useCoverShipmentMutation>
export type CoverShipmentMutationResult = Apollo.MutationResult<ICoverShipmentMutation>
export type CoverShipmentMutationOptions = Apollo.BaseMutationOptions<
  ICoverShipmentMutation,
  ICoverShipmentMutationVariables
>
